import { Injectable } from '@angular/core';
import { ReactiveProvider } from '../reactive-provider';
import { IRefund } from 'src/app/models/refund.model';

@Injectable()
export class RefundService extends ReactiveProvider<IRefund> {
  protected url = "events/refunds";
}